import * as asn1 from "asn1js"; // Import the asn1 module
import { Certificate, CertificationRequest } from "pkijs"; // Import the CertificationRequest class from pkijs

export const checkCSRString = (csrString: string) => {
  try {
    // Decode the Base64 string
    const decodedCSR = atob(csrString);
    const csrBuffer = new Uint8Array(
      decodedCSR.split("").map((char) => char.charCodeAt(0))
    );

    // Parse the CSR
    //const asn1Result = asn1.fromBER(csrBuffer.buffer);

    const pkcs10 = CertificationRequest.fromBER(csrBuffer.buffer);

    const fetchedStringCSR = pkcs10.subject
      .toJSON()
      .typesAndValues.filter((typeAndValues) => {
        return typeAndValues.type === "2.5.4.3";
      })[0].value.valueBlock.value;

    return fetchedStringCSR;
  } catch (error) {
    console.error("CSR validation error:", error);
    throw new Error(`CSR validation error`);
    // return "Invalid CSR";
  }
};

export const validateStartEnd = (csrText: string): string => {
  const beginMarker = "-----BEGIN CERTIFICATE REQUEST-----";
  const endMarker = "-----END CERTIFICATE REQUEST-----";

  // Check if the CSR text starts with the begin marker and ends with the end marker
  if (csrText.startsWith(beginMarker) && csrText.endsWith(endMarker)) {
    // Extract the text in between the markers
    const startIndex = beginMarker.length;
    const endIndex = csrText.length - endMarker.length;
    const csrContent = csrText.substring(startIndex, endIndex).trim();
    return csrContent;
  } else {
    throw new Error(
      "Invalid CSR format please make sure certificate is in PEM format"
    );
  }
};

export const checkCSRValuesafterDecode = (
  csrText: string,
  productId: string,
  tenantId: string
) => {
  const regex = /^ForgeForUtilities\.Connectors-([^.]+)\.([^.]+)$/;
  const match = csrText.match(regex);

  if (match) {
    const tenantIdFetched = match[1];
    const productIdFetched = match[2];

    // return { tenantId, productId };
    if (
      tenantIdFetched === tenantId &&
      productIdFetched.toLowerCase() === productId.toLowerCase()
    ) {
      return csrText;
    } else {
      throw new Error(
        `Invalid CSR format please make sure product is correctly selected, fetched subject is ${csrText}`
      );
    }
  } else {
    throw new Error(
      `Invalid CSR format please make sure product is correctly selected, fetched subject is ${csrText}`
    );
  }
};
export const validateCSR = (
  csrText: string,
  productId: string,
  tenantId: string
) => {
  const trimmedCsrText = csrText.trim();
  const validateStartEndVal: string = validateStartEnd(trimmedCsrText);
  const getDecodedString: string = checkCSRString(validateStartEndVal);
  return checkCSRValuesafterDecode(getDecodedString, productId, tenantId);
};
